import BaseModal from "components/modal/base";
import { useCalendarCardInfContext } from "../context";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { langProps } from "interface/index";
import i18n from "locales/i18n";
import { useUpdateStatus } from "./handlers";

type IProps = {
  isOpen: boolean;
  onClose: () => void;
};

export default function StatusModal({ isOpen, onClose }: IProps) {
  const { t } = useTranslation();
  const langCd = i18n.language;

  const { cardInf } = useCalendarCardInfContext();
  const { onUpdateStatus } = useUpdateStatus();

  const sellYn = cardInf?.sellStaCd === "S01" ? "Y" : "N";

  const txtRef = useRef<HTMLParagraphElement | null>(null);

  const txt = {
    ko: `현재 상품은 <b class="font-bold text-sm px-1 (${sellYn} === Y ? text-green-500 : text-red-500)">
    ${
      sellYn === "Y" ? t("status_sell_y") : t("status_sell_n")
    } </b> 상태입니다. </br >
  <b
    class="font-bold text-sm px-1 (${sellYn} === Y ? text-red-500 : text-green-500)"
  >
    ${
      sellYn === "Y" ? t("status_sell_n") : t("status_sell_y")
    }</b> 로 변경하시겠습니까?`,
    en: `The current product is in <b class="font-bold text-sm px-1 (${sellYn} === Y ? text-green-500 : text-red-500)">
    ${
      sellYn === "Y" ? t("status_sell_y") : t("status_sell_n")
    }</b> status. </br >
  Would you like to change it to 
  <b class="font-bold text-sm px-1 (${sellYn} === Y ? text-red-500 : text-green-500)">
    ${sellYn === "Y" ? t("status_sell_n") : t("status_sell_y")}</b>?`,
  };

  useEffect(() => {
    if (txtRef.current) {
      txtRef.current.innerHTML = txt[langCd as keyof langProps];
    }
  }, [txt, langCd]);
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={t("md_ttl_edit_status")}
    >
      <p className="text-sm text-center font-bold leading-6" ref={txtRef} />
      <div className="flex justify-center mt-5">
        <button className="btn bg-red-400" onClick={onUpdateStatus}>
          {t("btn_confirm")}
        </button>
      </div>
    </BaseModal>
  );
}
